import React from 'react';

import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import { getToday } from 'modules/client/common/helpers';

import { Field } from '../../../forms/companyConstituentDocsDate';

export const CompanyDateOfStructureChangeSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyDateOfLastChangeSection"
      title={t('client.legal.companyConstituentDocs.dateOfLastChange.title')}
    >
      <GridFields>
        <Field.DatePicker
          showRequiredMark
          label={t(
            'client.legal.companyConstituentDocs.dateOfLastChange.label'
          )}
          maxDate={getToday()}
          name="constituentDocsDateOfLastChange"
          placeholder={t(
            'client.legal.companyConstituentDocs.dateOfLastChange.placeholder'
          )}
        />
      </GridFields>
    </Section>
  );
};
